<template>
  <div
    :class="{
      'queue-card-wrapper': true,
      'room-order-card-rounded': showRoundedBorders,
    }"
  >
    <div :class="{
        'header': true,
        'header-closed': room_order.status == 'closed'
      }">
      <div class="header-info">
        <HeaderCheque :mode="'ROOMS'" :chequeId="room_order.local_id" />
         

        <ClientName
          class="room-card-client"
          :clientName="room_order.client_name"
          :systemColor="'hotels'"
        />

        <div class="cheque-list-details">
           
            <div class="cheque-detail-item">
              <img src="/icons/mobile-white.svg" />

              <p class="client-phone-value" @click="callPhone">
                {{ room_order.client_phone }}
              </p>
            </div>

            <div class="cheque-detail-item" v-if="room_order.target_date">
              <img src="/icons/time-white.svg" />

              <p>
                {{ targetTime }}
              </p>
            </div>

            <div class="cheque-detail-item">
              <img src="/icons/address-white.svg" />

              <p>
                {{ room_order.room_name }}
              </p>
            </div>

            <div class="cheque-detail-item">
              <img :src="'/icons/payment-white.svg'" />

              <p>
                {{
                  $t(`card.pay_methods.${room_order.pay_method || "online"}`)
                }}
              </p>
            </div>
          
        </div>

        <RoomOrderStatusBar :room_order="room_order" />
      </div>
    </div>

    <div class="room-order-card-body">
      <ItemList :list="room_order.list" />

      <div class="total-block">
        <h4 class="total">{{ $t("card.total") }}</h4>
        <span class="amount">{{ room_order.total }}{{ currency.symbol }}</span>
      </div>

      <div class="comment" v-if="room_order.comment">
        <h6 class="color-grey">{{ $t("card.comment") }}</h6>
        <p>{{ room_order.comment }}</p>
      </div>
    </div>
    <!-- <div class="order-actions-box"></div> -->

    <AcceptTimeControls
      v-model="waiting_time"
      :times="suggestedWaitingTimes"
      v-if="room_order.status == 'confirmed'"
    />

    <div v-if="room_order.status == 'confirmed'" class="order-actions-box">
      <QueueButton
        class="action-cancel-button"
        variant="cancel"
        @click="cancelling = true"
      >
        <img src="/icons/del.svg" class="del" />
      </QueueButton>
      <QueueButton @click="onAccept" class="w-100" variant="accept">{{
        $t("actions.preorder_accept")
      }}</QueueButton>
    </div>

    <div v-if="room_order.status == 'serving'" class="order-actions-box mb-0">
      <QueueButton @click="onPay" class="w-100" variant="dark">
        {{ $t("actions.pay") }}
      </QueueButton>
    </div>

    <template v-if="room_order.status == 'paying'">
      <div class="discount">
        <b>{{ $t("pay.set_discount") }}</b>

        <div class="form-group mb-0">
          <!-- <select class="form-control discount-combobox" v-model="pay.discount">
            <option v-for="d in discounts" :value="d">{{ d }}%</option>
          </select>-->
          <CenteredSelect
            class="form-control discount-combobox"
            v-model="discount"
            :suffix="'%'"
            :options="discounts"
          />
        </div>
      </div>

      <div class="choose-pay">
        <b>{{ $t("card.pay_method") }}</b>
        <div class="d-flex pt-15 justify-content-between">
          <div
            :class="{
              'pay-option': true,
              active: pay_method == 'cash',
            }"
            @click="pay_method = 'cash'"
          >
            {{ $t("pay.by_cash") }}
          </div>
          <div
            :class="{
              'pay-option': true,
              active: pay_method == 'card',
            }"
            @click="pay_method = 'card'"
          >
            {{ $t("pay.by_card") }}
          </div>
        </div>
      </div>

      <div class="overall">
        <h4 class="mb-0">{{ $t("card.to_pay") }}</h4>
        <span class="amount">
          {{ finalTotal
          }}{{ currency.symbol }}
        </span>
      </div>
    </template>

    <div v-if="room_order.status == 'paying'" class="order-actions-box mb-0">
      <QueueButton @click="onClose" class="w-100" variant="dark">
        {{ $t("preorder_card.action_close") }}
      </QueueButton>
    </div>

    <RefuseModal
      @cancel="cancelling = false"
      @confirm="onCancel"
      v-if="cancelling"
    />
  </div>
</template>

<script>
import ClientName from "@/components/ClientName.vue";
import HeaderCheque from "@/components/details/HeaderCheque.vue";
import ItemList from "@/components/item/ItemList.vue";

import RoomOrderStatusBar from "@/components/statusbar/RoomOrderStatusBar.vue";
import AcceptTimeControls from "@/components/item/AcceptTimeControls.vue";
import QueueButton from "@/components/QueueButton.vue";
import RefuseModal from "@/components/modals/RefuseModal.vue";

import CenteredSelect from "@/components/CenteredSelect.vue";

import moment from "moment";

export default {
  props: {
    room_order: Object,
  },
  data() {
    return {
      waiting_time: null,
      cancelling: false,
      pay_method: "cash",
      discount: 0,
    };
  },
  components: {
    ClientName,
    HeaderCheque,
    ItemList,
    RoomOrderStatusBar,
    AcceptTimeControls,
    QueueButton,
    RefuseModal,
    CenteredSelect,
  },
  methods: {
    callPhone() {
      window.location.href = `tel:${this.room_order.client_phone}`;
    },
    onCancel(reason) {
      this.$store.dispatch("hotels/cancelRoomOrder", {
        id: this.room_order._id,
        reason,
      });

      this.cancelling = false;
    },
    onAccept() {
      this.$store.dispatch("hotels/acceptRoomOrder", {
        id: this.room_order._id,
        waiting_time: this.waiting_time,
      });
    },
    onClose() {
      this.$store.dispatch("hotels/closeRoomOrder", {
        id: this.room_order._id,
        pay_method: this.pay_method,
        discount: this.discount
      });
    },
    onPay() {
      this.$store.dispatch("hotels/payRoomOrder", {
        id: this.room_order._id,
      });
    },
  },
  computed: {
    targetTime() {
      if (!this.room_order.target_date) return "";
      return moment(this.room_order.target_date).format("HH:mm");
    },
    currency() {
      return this.$store.state.currency;
    },
    suggestedWaitingTimes() {
      return this.$store.state.waiting_times.hotels;
    },
    showRoundedBorders() {
      return ["closed", "cancelled"].includes(
        this.room_order.status
      );
    },
    discounts() {
      const discounts = [];
      for (let i = 0; i <= 105; i += 5) discounts.push(i);

      return discounts;
    },
    finalTotal() {
      if (!this.discount) return this.room_order.total;

      return Math.round(
        this.room_order.total * ((100 - this.discount) / 100)
      );
    }
  },
  mounted() {
    this.pay_method = this.room_order.pay_method;
  }
};
</script>

<style scoped>
.room-order-card {
  width: 90vw;
  position: relative;
  z-index: 1;
  margin: 2.5vh auto 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background: #ededed;
  border-radius: 5vh;
  
}

.room-order-card-rounded {
  border-radius: 2.5vh;
}

.room-card-actions {
  display: flex;
  justify-content: space-between;
  margin: 3.7vh 5.4vw 0;
}

.header {
  background-color: #1d1d1b;
  color: #ededed;
  border-radius: 2.5vh 2.5vh 0 0;
}

.header-closed {
  background-color: #129b81;
}

.order-id {
  display: flex;
  justify-content: space-between;
  padding: 2.5vh 5.4vw 1.9vh;
}

.order-id h3 {
  margin-bottom: 0;
}

.order-id span {
  position: relative;
  right: 0;
  font-size: 4vw;
}

.room-card-client {
  background: #ededed;
}

.total-block {
  line-height: 0.8;
  padding: 0 5.4vw;
  margin-top: 2.5vh;
}

.total {
  display: inline-block;
  margin: 0 !important;
  font-size: 6.5vw;
  text-align: initial;
  padding-top: 0.9vh;
  line-height: 0.8;
}

span.amount {
  float: right;
  margin-top: 0vh;
  line-height: 0.8;
  font-size: 9.6vw;
  font-weight: 500;
}

.comment {
  padding: 0 5.4vw;
  margin-top: 2.5vh;
}

.comment h6 {
  font-weight: 500;
  font-size: 5vw;
  margin-bottom: 0;
}

.comment p {
  padding: 1.3vh 4vw 0;
  margin-bottom: 0;
  font-size: 4.5vw;
}

.choose-pay {
  width: 100%;
  padding: 2.5vh 5.4vw 0;
}

.pay-option {
  background: #ededed;
  color: #1d1d1b;
  cursor: pointer;
  width: 45%;
  text-align: center;
  padding: 2.2vh 4vw 2vh;
  line-height: 0.8;
  border: 2px solid transparent;
  border-radius: 10px;
  font-weight: 600;
  box-shadow: 0px 1px 7px #dadada;
}

.option-icon {
  margin: 5px -25px 0 10px;
  float: left;
}

.pay-option.active {
  border: 2px solid #129b81;
  padding: 2.1vh 4vw 2vh;
}

.discount b,
.choose-pay b {
  font-weight: 400;
  line-height: 0.8;
  font-size: 5vw;
}

.discount {
  padding: 2.5vh 5.4vw 0;
}

.discount-combobox {
  text-align-last: center;
  text-align: -webkit-center;
  background: #ededed;
  border: 1px solid #a4a3a1;
  font-size: 3vh;
  font-weight: bold;
  padding: 0.2vh 0 0.4vh;
  color: #5a5a5a;
  border-radius: 5vh;
}

.form-group {
  text-align-last: center;
  margin: 1.9vh auto 0;
  background: #ededed;
  box-shadow: 0px 1px 7px #dadada;
  border: none;
  font-weight: bold;
  color: #5a5a5a;
  border-radius: 5vh;
}

.form-control {
  height: auto;
}

.overall {
  padding: 0 5.4vw;
  margin-top: 3.7vh;
}

.overall h4 {
  width: 35vw;
  display: inline-block;
  padding-top: 0.4vh;
}

.total {
  font-weight: bold;
  display: inline-block;
  margin: 0 !important;
  font-size: 6.5vw;
  text-align: initial;
  padding-top: 0.9vh;
  line-height: 0.8;
}

@media screen and (min-width: 768px) {
  .room-order-card {
        width: 23.264vw;
    margin: 1.389vw auto 1.389vw;
    border-radius: 1.389vw 1.389vw 2.778vw 2.778vw;
    padding-bottom: 0.694vw;
  }
 .discount {
    padding: 1.389vw 1.389vw;
  }
  .discount b {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .form-control.discount-combobox {
    width: 100%;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .choose-pay {
    padding: 0 1.389vw;
  }
  .choose-pay b {
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .pay-option {
    padding: 1.5vh 2vh !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25vw;
    line-height: 1.458vw;
  }
  .overall {
    padding: 0 1.389vw;
    margin-top: 1.389vw;
  }
    h4.mb-0 {
    font-size: 1.667vw;
    line-height: 1.944vw;
    width: auto;
  }
  span.amount {
    font-size: 2.5vw;
    line-height: 2.847vw;
  }
  .order-actions-box {
        margin: 2vh 1.389vw 1.389vw;
  }

  .order-id {
    display: flex;
    justify-content: space-between;
    padding: 1.736vw 1.389vw 1.389vw;
  }
  .order-id h3 {
    font-size: 2.083vw;
    line-height: 2.431vw;
  }
  .order-id span {
    font-size: 1.042vw;
    line-height: 1.181vw;
}
h3.d-inline {
    font-size: 2.083vw;
    line-height: 2.431vw;
}

.total-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.389vw;
  margin: 0;
  line-height: 0.8;
}

h4.total {
    font-size: 1.667vw;
    line-height: 1.944vw;
}

span.amount {
    font-size: 2.5vw;
    line-height: 0.7;
}

.comment {
  padding: 0 1.389vw 2.2vh;
  margin-top: 2.5vh;
}

.comment h6 {
  font-size: 1.25vw;
    line-height: 1.458vw;
    font-weight: 500;
    margin: 0;
}

.comment p {
  padding: 0.694vw 0.69vw 0;
    font-size: 0.903vw;
    line-height: 1.042vw;
    margin: 0;
}

}

</style>